module.exports = __webpack_public_path__ + "img/logo_FF5__simplon.61583b64.svg";